module.exports = __webpack_public_path__ + "static/media/FORMULARIO_MEDICACION_ONCOLOGICA_01.d8fbebd3.pdf";